/**
 * @generated SignedSource<<defa37079ef4683635bad64f739e4fa8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MicrosoftTodoImportExistingTicketPaneTaskPreviewQuery$variables = {
  listId: string;
  taskId: string;
};
export type MicrosoftTodoImportExistingTicketPaneTaskPreviewQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly microsoftTodo: {
        readonly taskPreview: {
          readonly assignee: {
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
          } | null;
          readonly done: boolean | null;
          readonly due: any | null;
          readonly externalId: string;
          readonly title: string;
        } | null;
      } | null;
    };
  };
};
export type MicrosoftTodoImportExistingTicketPaneTaskPreviewQuery = {
  response: MicrosoftTodoImportExistingTicketPaneTaskPreviewQuery$data;
  variables: MicrosoftTodoImportExistingTicketPaneTaskPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "listId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "listId",
    "variableName": "listId"
  },
  {
    "kind": "Variable",
    "name": "taskId",
    "variableName": "taskId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "due",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MicrosoftTodoImportExistingTicketPaneTaskPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrosoftTodoUserNode",
                "kind": "LinkedField",
                "name": "microsoftTodo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v2/*: any*/),
                    "concreteType": "MicrosoftTodoTaskPreviewNode",
                    "kind": "LinkedField",
                    "name": "taskPreview",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MicrosoftTodoImportExistingTicketPaneTaskPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MicrosoftTodoUserNode",
                "kind": "LinkedField",
                "name": "microsoftTodo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v2/*: any*/),
                    "concreteType": "MicrosoftTodoTaskPreviewNode",
                    "kind": "LinkedField",
                    "name": "taskPreview",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v8/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9854935807ea350747399cbd363b0fe6",
    "id": null,
    "metadata": {},
    "name": "MicrosoftTodoImportExistingTicketPaneTaskPreviewQuery",
    "operationKind": "query",
    "text": "query MicrosoftTodoImportExistingTicketPaneTaskPreviewQuery(\n  $taskId: String!\n  $listId: String!\n) {\n  viewer {\n    integrations {\n      microsoftTodo {\n        taskPreview(taskId: $taskId, listId: $listId) {\n          title\n          externalId\n          due\n          done\n          assignee {\n            id\n            fullName\n            image\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "970963da8bb7759821655feb8d9eb6b0";

export default node;
